var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineFlag2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.7 22V2c0-.41.34-.75.75-.75s.75.34.75.75v20c0 .41-.34.75-.75.75s-.75-.34-.75-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.28 17.33a.748.748 0 0 1 .34-1l8.3-4.1c1.22-.63 1.91-1.39 1.88-2.1-.03-.69-.77-1.4-2.04-1.94l-8.1-3.5a.756.756 0 0 1-.4-.99c.16-.38.61-.56.99-.39l8.1 3.5c2.5 1.06 2.92 2.5 2.95 3.26.05 1.33-.91 2.57-2.7 3.49l-8.31 4.11c-.11.06-.23.08-.34.08-.28 0-.54-.15-.67-.42z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineFlag2);
export default __webpack_public_path__ + "static/media/vuesax-outline-flag-2.3cce66e3751c5049c59378a7e3f738da.svg";
export { ForwardRef as ReactComponent };